import React from 'react';

function DownloadArrow(props: object) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9375 1.25V2.1875V10.8617L13.3996 8.39959L14.0625 7.73668L15.3884 9.0625L14.7254 9.72541L10.8839 13.567C10.3957 14.0551 9.60427 14.0551 9.11611 13.567L5.27459 9.72541L4.61168 9.0625L5.9375 7.73668L6.60041 8.39959L9.0625 10.8617V2.1875V1.25H10.9375ZM16.875 11.5625V16.875H3.125V11.5625V10.625H1.25V11.5625V17.5C1.25 18.1904 1.80964 18.75 2.5 18.75H17.5C18.1904 18.75 18.75 18.1904 18.75 17.5V11.5625V10.625H16.875V11.5625Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default DownloadArrow;
